import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { environment } from 'environments/environment';
import { User, Role } from 'app/auth/models';
import { ToastrService } from 'ngx-toastr';

@Injectable({ providedIn: 'root' })
export class AuthenticationService {
  public currentUser: Observable<User>;

  private currentUserSubject: BehaviorSubject<User>;

  constructor(private _http: HttpClient, private _toastrService: ToastrService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('user')));
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }


  get isAdmin() {
    return this.currentUser && this.currentUserSubject.value.role === Role.Admin;
  }

  get isClient() {
    return this.currentUser && this.currentUserSubject.value.role === Role.Client;
  }

  getAccessTokenHeader() {
    if (localStorage.getItem('tokens')) {
      return { 'Authorization': 'Bearer ' + JSON.parse(localStorage.getItem('tokens')).access.token };
    }
    return null;
  }

  login(email: string, password: string) {
    return this._http
      .post<any>(`${environment.apiUrl}/v1/auth/login`, { email, password })
      .pipe(
        map(data => {
          // login successful if there's a jwt token in the response
          if (data.user && data.tokens) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('user', JSON.stringify(data.user));
            localStorage.setItem('tokens', JSON.stringify(data.tokens));

            // Display welcome toast!
            setTimeout(() => {
              this._toastrService.success(
                'Успешен вход',
                '👋 Здравейте, ' + data.user.name + '!',
                { toastClass: 'toast ngx-toastr', closeButton: true }
              );
            }, 2500);

            // notify
            this.currentUserSubject.next(data.user);
          }

          return data.user;
        })
      );
  }

  logout() {
    localStorage.clear();
  }
}
